import React from 'react';
import Preview from 'chat/components/_shared/Preview';
import { fromLinkPreviewGQLToLinkPreview } from 'chat/components/_shared/types/LinkPreviewType';
import './LinkPreviewContainer.scss';
import { LinkPreview_linkPreview } from 'chat/queries/__generated__/LinkPreview';

export interface Props {
  linkPreviews?: LinkPreview_linkPreview[];
}

const LinkPreviewContainer = ({ linkPreviews }: Props) => {
  if (!linkPreviews || !linkPreviews.length) {
    return null;
  }
  return (
    <>
      {linkPreviews.map((linkPreview: LinkPreview_linkPreview, index: number) => (
        <div
          className="LinkPreviewContainer-linkPreview"
          key={'LinkPreviewContainer-linkPreview-' + index}
        >
          <Preview
            linkPreview={fromLinkPreviewGQLToLinkPreview(linkPreview)}
            expand={true}
            showTooltips={false}
          />
        </div>
      ))}
    </>
  );
};

export default LinkPreviewContainer;
